import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { BaseInputFieldComponent } from '../base/base-input-field.component';

@Component({
  selector: 'shared-ui-inputs-text-field',
  templateUrl: './text-field.component.html',
  styleUrls: ['./text-field.component.css'],
  standalone: false,
})
export class TextFieldComponent extends BaseInputFieldComponent implements AfterViewInit {
  @Input() numRows = 3;
  @Input() placeholder: string | undefined;
  @Input() isFocused = false;
  @Input() fontStyle = 'fst-normal';

  @ViewChild('inputEl') inputEl?: ElementRef;

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    if (this.isFocused && this.inputEl) {
      this.inputEl.nativeElement.focus();
    }
  }
}
